<template>
  <v-list-group
    v-if="menuItem.children"
    no-action
    :group="menuItem.namespace"
  >
   <template v-slot:activator>
     <v-list-item-icon>
       <v-icon>{{ menuItem.icon }}</v-icon>
     </v-list-item-icon>
     <v-list-item-content>
       <v-list-item-title v-text="menuItem.title"></v-list-item-title>
     </v-list-item-content>
   </template>

   <v-list-item
     v-for="subItem in item.children"
     :key="menuItem.title + '-' + subItem.title"
     :to="{ name: subItem.routeName }"
   >
     <v-list-item-icon>
       <v-icon>{{ subItem.icon }}</v-icon>
     </v-list-item-icon>
     <v-list-item-content>
       <v-list-item-title v-text="subItem.title"></v-list-item-title>
     </v-list-item-content>
   </v-list-item>
 </v-list-group>

  <v-list-item
    v-else
    :to="{ name: menuItem.routeName }"
    :exact="(menuItem.routeName == exactLink)"
  >
   <v-list-item-icon>
     <v-icon>{{ menuItem.icon }}</v-icon>
   </v-list-item-icon>
   <v-list-item-content>
     <v-list-item-title v-text="menuItem.title"></v-list-item-title>
   </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'MenuItem',
  props: ['menuItem', 'exactLink'],
}
</script>

<style>

</style>